import theme from '@/constants/theme';

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
    flex: 1,
    overflow: "auto",
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  compactHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  emoji: {
    color: theme.colors.primary,
    fontSize: 198,
  },
  title: {
    color: theme.colors.text.title,
  },
  subtitle: {
    color: theme.colors.text.subtitle,
    fontSize: 20,
    maxWidth: 500,
    textAlign: 'center',
    textWrap: 'balance',
  },
  achivementsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    color: theme.colors.text.body,
    listStyle: 'none',
  },
  achivement: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  checkIcon: {
    display: 'flex',
    gap: 8,
    backgroundColor: theme.colors.background.secondary,
    padding: 8,
    borderRadius: 100,
  },
};

export default styles;
